
<template>
  <div>
    <messagePopup
      dialogTitle="易派客提醒您："
      :dialogType="''"
      :popupTop="'10vh'"
      :showClose="false"
      :centerDialogVisible="dialogVisible"
      @updateVisible="dialogVisible = false"
      @resetPopupData="dialogVisible = false"
      :popupWidth="'800px'"
      :showBtn="false"
    >
      <div class="box">
        <div class="content_box">
          <div class="box_li">
            <div class="box_title" @click="handleProtocol">
              <span>易派客注册会员服务协议</span>
              <i v-show="isProtocol" class="el-icon-arrow-up"></i>
              <i v-show="!isProtocol" class="el-icon-arrow-down"></i>
            </div>
            <div class="box_content" v-show="isProtocol">
              <div class="hint">
                <i class="el-icon-warning-outline"></i>
                <span style="line-height: 32px"
                  >温馨提示：由于系统版本升级，请重新签订《易派客注册会员服务协议》。</span
                >
              </div>
              <div>
                <div class="box_text" v-html="protocol"></div>
                <div class="box_text" style="margin: 20px 0; display: flex">
                  <el-checkbox
                    :value="checked_Protocol"
                    @change="handleChangeProtocol"
                  ></el-checkbox>
                  <span style="margin-left: 10px"
                    >本公司已认真阅读、理解并同意《易派客注册会员服务协议》的全部内容，并将严格遵照执行。一经勾选即视为签署。如有违反，同意按照《易派客注册会员服务协议》内容承担相应责任。</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="box_li"
            v-show="
              userInfo.memberIdentity != 'purchase' && userInfo.identity != '' && resultType.type == '2'
            "
          >
            <div>
              <div class="box_title" @click="handleLiability">
                <span>廉洁从业责任书</span>
                <i v-show="isLiability" class="el-icon-arrow-up"></i>
                <i v-show="!isLiability" class="el-icon-arrow-down"></i>
              </div>
              <div class="box_content" v-show="isLiability">
                <div class="hint">
                  <i class="el-icon-warning-outline"></i>
                  <span style="line-height: 32px"
                    >温馨提示：由于系统版本升级，请重新签订《廉洁从业责任书》。</span
                  >
                </div>
                <div>
                  <div class="box_text" v-html="liability"></div>
                  <div class="box_text" style="width: 100%; display: flex">
                    <div
                      style="width: 50%; display: flex; flex-direction: column"
                    >
                      <p>甲方单位：中国石油化工股份有限公司物资装备部</p>
                      <p>法定代表人：王玉冰</p>
                      <p>日期：{{ dateTime }}</p>
                      <p>地址：北京市朝阳区朝阳门北大街22号</p>
                      <p>电话：010-59963628</p>
                    </div>
                    <div
                      style="width: 50%; display: flex; flex-direction: column"
                    >
                      <p>乙方单位：{{ companyData.companyname }}</p>
                      <p>法定代表人：{{ companyData.legalrepresentative }}</p>
                      <p>日期：{{ dateTime }}</p>
                      <p>地址：{{ companyData.regcity }}</p>
                      <p>联系方式：{{ companyData.telephone }}</p>
                    </div>
                  </div>
                  <div class="box_text" style="margin: 20px 0; display: flex">
                    <el-checkbox
                      :value="checked_liability"
                      @change="handleChangeLiability"
                    ></el-checkbox>
                    <span style="margin-left: 10px"
                      >本公司已认真阅读、理解并同意《廉洁从业责任书》的全部内容，并将严格遵照执行。一经勾选即视为签署。如有违反，同意按照《廉洁从业责任书》内容承担相应责任。</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit_btn" @click="handleSubmit()">提交</div>
      </div>
    </messagePopup>
  </div>
</template>

<script>
import { liability, protocol } from '@/assets/js/cerword.js'
import messagePopup from "./e-messagePopup.vue";
import api from "../../modules/projectA/api/nesting";
import { debounce } from "@/modules/projectA/utils/throttle.js"
export default {
  components: {
    messagePopup,
  },
  data () {
    return {
      dialogVisible: false,
      form: {
        newPassword: '',
        repetitionPassword: '',
      },
      isProtocol: false,
      isLiability: true,
      checked_liability: false,
      checked_Protocol: true,
      liability,
      protocol,
      userInfo: {},
      dateTime: '',
      resultType: '',
      companyData: {
        companyname: '',
        legalrepresentative: '',
        regcity: '',
        telephone: ''
      }
    }
  },
  created () {
    this.getContextObjectAndRemark();
  },
  mounted () {
    let date = new Date();
    this.dateTime = date.toLocaleDateString().replace(/\//g, '-');
  },
  computed: {

  },
  methods: {
    handleSubmit () {
      debounce(() => {
      if (this.checked_Protocol) {
        if (this.resultType.type == "1") {
          this.changeAgreement();
        } else if (this.resultType.type == "2") {
          if (this.checked_liability) {
            this.changeAgreement();
          } else {
            this.$message.warning("请先勾选《廉洁从业责任书》");
          }
        }
      } else {
        return this.$message.warning("请先勾选《易派客注册会员服务协议》");
      }
      },1000)
    },

    changeAgreement () {
      this.dialogVisible = false;
      api.changeAgreement({ type: this.resultType.type }).then(res => {
        let agreement = JSON.parse(res.data.returnResult).agreement;
        if (res.code == 200 && agreement) {
          this.$message.success('提交成功');
        } else {
          this.$message.error('提交失败');
        }
      })
    },


    // 协议
    handleProtocol () {
      this.isProtocol = !this.isProtocol;
    },
    // 廉洁责任书
    handleLiability () {
      this.isLiability = !this.isLiability;
    },

    handleChangeLiability () {
      this.checked_liability = !this.checked_liability;
    },
    handleChangeProtocol () {
      this.checked_Protocol = !this.checked_Protocol;
    },

    async getContextObjectAndRemark () {
      const userInfo = this.$store.state.USERINFO;
      if (userInfo?.memberSource === 'zhongjian') return;
      let res = await api.getContextObjectAndRemark({ bussType: "103" });
      if (res.code == "200") {
        this.userInfo = this.$store.state.USERINFO;
        this.resultType = JSON.parse(res.data.returnResult);
        if (this.resultType.company && this.resultType.companyContacts) {
          let company = JSON.parse(res.data.returnResult).company;
          let companyContacts = JSON.parse(res.data.returnResult).companyContacts;
          this.companyData.companyname = company.companyname;
          this.companyData.legalrepresentative = company.legalrepresentative;
          this.companyData.regcity = company.regcity;
          this.companyData.telephone = companyContacts.telephone;
        }
        // 个人用户不弹弹框
        if (this.userInfo.companyId) {
          // 0：已勾选，1：廉洁责任书未勾选，2：供应商两个未勾选 ~ 协议复选框默认勾选
          // resultType == 2 弹廉洁责任书
              switch(this.resultType.type){
            case "0" :
              this.dialogVisible = false;
              break;
            case "1" :
              this.isProtocol = true;
              this.dialogVisible = true;
              break;
            case "2" :
              this.dialogVisible = true;
              break;
          }
        } else {
          this.dialogVisible = false;
        }
      }
    },


  },


}
</script>

<style lang='scss' scoped>
.box {
  padding: 0 30px 20px;
  .content_box {
    width: 100%;
    min-height: 108px;
    .box_li {
      width: 100%;
      min-height: 53px;
      border-bottom: 1px solid #d9d9d9;
      .box_title {
        font-weight: 700;
        box-sizing: border-box;
        padding: 0 20px;
        width: 100%;
        height: 53px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        font-size: 14px;
      }
    }
    .box_content {
      width: 100%;
      height: 290px;
      box-sizing: border-box;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: scroll;
      .hint {
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        background: #e8efff;
        color: #666;
        font-size: 12px;
        i {
          margin: 0 10px;
          color: #2587ff;
        }
      }
      .box_text {
        font-size: 12px;
        line-height: 21px;
        color: #000;
        text-align: justify;
      }
    }
  }
  .submit_btn {
    margin: 20px auto 0;
    cursor: pointer;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2587ff;
    color: #fff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
::v-deep.el-input__inner {
  width: 300px;
  border-radius: 0;
  color: #333;
}
::v-deep.el-form-item__label {
  font-size: 14px;
  color: #333;
}
</style>
